/* 
 * NOTICE OF LICENSE
 * 
 * This source file is subject to the Academic Free License (AFL 3.0)
 * 
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2019 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import $ from 'jquery';

( function() {
    
    var _back = $('.js-back-to-top');
    var _header = $('.js-header');
    var _scrollBox = $('.js-scroll-box');
    var _scrollto = $('.js-scroll-to');

    $(window).on('scroll', { passive: true } , function (){
        var scrolltop = $(window).scrollTop();


        if(scrolltop > 200 && scrolltop <= 400){
            _header.addClass('header--hide');
        }
        if( scrolltop < 200 && scrolltop <= 400 ){
            _header.removeClass('header--hide');
        }
        
        if(scrolltop > 300 && scrolltop <= 400){
            _header.addClass('header--fixed');
        }
        if( scrolltop < 300 && scrolltop <= 400 ){
            _header.removeClass('header--fixed');
        }
        
        if(scrolltop > 400){                    
            _header.addClass('solid-color');
        }
        if(scrolltop <= 400){
            _header.removeClass('solid-color');
        }
        

        if(scrolltop > 300){
            _back.removeClass('back-to-top--hide');
        }else{
            _back.addClass('back-to-top--hide');
        }

        if(scrolltop > 300){
            _scrollBox.addClass('scroll--hide');
            _scrollto.addClass('scroll--hide');
        }else{
            _scrollBox.removeClass('scroll--hide');
            _scrollto.removeClass('scroll--hide');
        }
    });

    _back.on('click', function (){
        $("html, body").animate({scrollTop: 0}, 1000);
    });
    _scrollto.on('click', function (e){
        e.preventDefault();            
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 500);
    });
    
    $('.js-scroll-links').on('click', function (e){
        e.preventDefault();   
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - 60
        }, 1000);

    });
    
} )();